import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Subtract18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 8H15V9.5H3V8Z'
      fill='currentColor'
    />
  </Svg>
);

Subtract18.displayName = 'Subtract18';
export default Subtract18;
